import { getToken, getRefreshToken } from '../authentication/authProvider';

/**
 * Ask the backend to set the funeral's witness / private-identification flags
 * from the lines of all its contracts.
 *
 * For contract writes that go straight to PostgREST (the Qualify button), which
 * skip the NestJS paths that keep `funerals.has_visitation` and
 * `has_private_identification` in step with the lines. The derivation lives in
 * NestJS (contract-add-on-flags.ts) so every writer applies the same item ids.
 *
 * Never throws: the flags are a side effect of the contract write, and a
 * failure here must not fail the qualification.
 */
export const syncAddOnFlagsForFuneral = async (
  funeralId: number | string
): Promise<void> => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_PAPERMAN_API_URL}contract/sync-add-on-flags/${funeralId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${await getToken()}`,
          'Refresh-Token': await getRefreshToken(),
        },
      }
    );
    if (!response.ok) {
      console.error(
        'Add-on flag sync failed for funeral',
        funeralId,
        response.status
      );
    }
  } catch (error) {
    console.error('Add-on flag sync threw for funeral', funeralId, error);
  }
};
